<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, DatePicker },
    data() {
        return {
            title: "Historial Pagos Laborantes",
            items: [
                {
                text: "Laborantes",
                href: "/"
                },
                {
                text: "Pago",
                active: true
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            desde:'',
            hasta:'',
            pagos_laborantes:[],
            laborantes:[],
            eventos:[],
        };
    },
    computed:{
        rows() {
            return this.filteredData.length;
        },
        filteredData() {
            const filtro = this.normalizarTexto(this.filtro);

            if (!filtro) {
                return this.pagos_laborantes;
            }

            return this.pagos_laborantes.filter((item) => {
                const nombreLaborante = this.normalizarTexto(this.obtenerLabotante(item.laborante_id));
                const tipoLaborante = this.normalizarTexto(item.tipo_laborante);
                const codigoEvento = this.normalizarTexto(this.obtenerEvento(item.evento_id).codigo);
                const coordinadorEvento = this.normalizarTexto(this.obtenerEvento(item.evento_id).coordinador_evento);
                const fecha = this.normalizarTexto(this.formatFecha(item.fecha));

                return nombreLaborante.includes(filtro)
                    || tipoLaborante.includes(filtro)
                    || codigoEvento.includes(filtro)
                    || coordinadorEvento.includes(filtro)
                    || fecha.includes(filtro);
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        normalizarTexto(valor) {
            return (valor || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim();
        },
        obtenerRangoFechas() {
            const hoy = new Date();
            const diaHoy = hoy.getDate();
            const mesHoy = hoy.getMonth();
            const anioHoy = hoy.getFullYear();

            let fechaInicio, fechaFin;

            if (diaHoy <= 25) {
                // Si hoy es menor o igual a 25, el rango es del 26 del mes anterior al 25 de este mes
                const mesAnterior = mesHoy === 0 ? 11 : mesHoy - 1;
                const anioInicio = mesHoy === 0 ? anioHoy - 1 : anioHoy;
                fechaInicio = new Date(anioInicio, mesAnterior, 26);
                fechaFin = new Date(anioHoy, mesHoy, 25);
            } else {
                // Si hoy es mayor a 25, el rango es del 26 de este mes al 25 del mes siguiente
                const mesSiguiente = mesHoy === 11 ? 0 : mesHoy + 1;
                const anioFin = mesHoy === 11 ? anioHoy + 1 : anioHoy;
                fechaInicio = new Date(anioHoy, mesHoy, 26);
                fechaFin = new Date(anioFin, mesSiguiente, 25);
            }
            this.desde = moment(fechaInicio).format('YYYY-MM-DD');
            this.hasta = moment(fechaFin).format('YYYY-MM-DD');
            //return { fechaInicio, fechaFin };
        },
        fecha_mes_actual(val){
            const fechaActual = new Date(); // Obtiene la fecha actual
            const primerDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(),val); // Configura el día como 1
            return moment(primerDiaMes).format('YYYY-MM-DD');
        },
        mostrarmes(){
            axios.get('/api/pagos_historial/'+this.desde+'/'+this.hasta).then(response => {
                this.pagos_laborantes= response.data.pagos_laborantes;
                this.currentPage = 1;
            });
        },
        obtenerLabotante(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0].name;
            }
        },
        obtenerEvento(element){
            let evento = this.eventos.filter((us) => us.id==element);
            if (evento.length>0) {
                return evento[0];
            }else{
                let evento={
                    codigo:'',
                    coordinador_evento:'',
                }
                return evento
            }
        },
        msg(title) {
            Swal.fire({
                icon: 'success',
                title: title,
                //text: `Por favor, completa el campo "${campo}".`,
                showConfirmButton: false,
                timer: 1000
            });
        },
        seleccionar(item){
            let formData = new FormData();
            formData.append('pago_id', item.id);
            formData.append('status', item.status);
            axios.post('/api/seleccionar_pago',formData).then(response => {
                this.msg('Guardado')
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
    },
    created(){
        this.obtenerRangoFechas();
        axios.get('/api/pagos_historial/'+this.desde+'/'+this.hasta).then(response => {
            this.pagos_laborantes= response.data.pagos_laborantes;
            this.currentPage = 1;
        });
        axios.get('/api/get_laborantes').then(response => {
            this.laborantes= response.data.usuarios;
        });
        axios.get('/api/get_eventos').then(response => {
            this.eventos= response.data.eventos;
        });
    }
    ,
    watch: {
        filtro() {
            this.currentPage = 1;
        },
        perPage() {
            this.currentPage = 1;
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Desde :" label-for="text" >
                                    <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Hasta :" label-for="text" >
                                    <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-button variant="primary" block class="mb-4" @click="mostrarmes">Ver</b-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th >Nombre</th>
                                        <th >Tipo</th>
                                        <th >Fecha</th>
                                        <th >Hora inicio</th>
                                        <th >Hora fin</th>
                                        <th >Total hora</th>
                                        <th >Código evento</th>
                                        <th >Coordinador</th>
                                        <th >Valor Bruto</th>
                                        <th >Valor Líquido</th>
                                        <th >Fecha Pago</th>
                                        <!-- <th >Acción</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>{{ obtenerLabotante(item.laborante_id) }}</td>
                                        <td>{{ item.tipo_laborante }}</td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ item.hora_inicio }}</td>
                                        <td>{{ item.hora_fin }}</td>
                                        <td>{{ item.total_horas }}</td>
                                        <td>{{ obtenerEvento(item.evento_id).codigo }}</td>
                                        <td>{{ obtenerEvento(item.evento_id).coordinador_evento }}</td>
                                        <td>{{ format_Valor_variable(item.valor_bruto) }}</td>
                                        <td>{{ format_Valor_variable(item.valor_liquido) }}</td>
                                        <td>{{ formatFecha(item.fecha_pago) }}</td>
                                        <!-- <td>

                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
